import { DatasetStatus } from '@components'
import { ProcessingStatusChip, StatusChip, getStatusLabel } from './statusChips'

interface Props {
  status: DatasetStatus
}

/**
 * Banner to show the submission processing status.
 * @param props React.props
 * @param {string} props.status The text status.
 * @returns
 */
export const SubmissionStatusIndicator = ({ status }: Props) => {
  const isProcessing = status === DatasetStatus.PENDING || status === DatasetStatus.APPROVED
  const label = getStatusLabel(status)

  return isProcessing ? (
    <ProcessingStatusChip status={status} label={label} />
  ) : (
    <StatusChip status={status} label={label} />
  )
}
